var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-button', { attrs: { "icon": "el-icon-fa-cloud-upload", "type": "text" }, on: { "click": _vm.openResourcesDialog } }, [_vm._v("\n  云端上传\n")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };